import React from 'react';
import { useQuery } from 'react-query';

import ProductCard from 'common/Product';
import Paragraph from 'components/atoms/Paragraph';
import Container from 'components/organisms/Container';
import { getProductService } from 'services/product';

const Products: React.FC<{ title?: string }> = ({ title }) => {
  const { data: dataProductsHot } = useQuery(
    ['NEWS_PRODUCT_HOT'],
    () => getProductService({
      page: 1,
      limit: 10,
      /* sort: 'sold', */
      sort: 'created_date',
      sort_order: 'desc'
    }),
    {
      enabled: true,
    }
  );

  return (
    <section className="u-mt-48 u-mt-md-60 u-mt-lg-80">
      <Container>
        <div className="text-md-center">
          <Paragraph.Heading
            type="h4"
            content={title}
            modifiers={['700', 'raisinBlack']}
            size={{
              fontSize: '36',
              lineHeight: '43'
            }}
            sizeTablet={{
              fontSize: '24',
              lineHeight: '29'
            }}
          />
        </div>

        <div className="p-newsDetail_product_row">
          {dataProductsHot?.data.map((product) => (
            <div
              className="p-newsDetail_product_col u-mt-16 u-mt-md-26"
              key={`card-product-${product.id}`}
            >
              <ProductCard {...product} />
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
};

export default Products;
